import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { useNavigate } from 'react-router-dom';
import {
    MDBContainer,
    MDBInput,
    //MDBBtn,
} from 'mdb-react-ui-kit';


    
const CreateOrder = () => {
  const [message, setMessage] = useState('');
  const [username, setUserName] = useState('');
  const [itemName, setItemName] = useState('PAY');
    const [totalAmount, setTotalAmount] = useState('');
    const [error, setError] = useState('');
    const history = useNavigate();
    //const apiUrl = process.env.REACT_APP_API_URL;

    const handleLogin = async () => {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem('jwtToken'); // Retrieve JWT token from localStorage
    console.log('JWT token retrieved:', token);
      try {
          if (!itemName || !totalAmount) {
              setError('Please enter both username and password.');
              return;
          }

          const response = await axios.post('http://muvitapp.com/webapp3/', /* { itemName, totalAmount }, */
          // const response = await axios.post(`${apiUrl}/orders`,
            {    
              "orderItem":itemName,
              "orderDate": "2024-12-05",
              "totalAmount": totalAmount
              
          }
           ,

          {
              headers: {
                "Authorization": `Bearer ${token}`,  // Attach JWT token to Authorization header
                
                //"Content-Type": "application/json"    // Optional: You can specify other headers if needed
              }
            }
          );
          console.log('Login successful with JWT token granted:', response.data);
          
          
          if (response.data) {
              
              /* sessionStorage.setItem('jwtToken', response.data);
              console.log('JWT token saved');
              sessionStorage.setItem('sessionusername', username);
              console.log('sesssion username: ', username); */
              const obj = response.data;
             const url = obj.paymentUrl;
              console.log('obtained payment URL: ', obj);
              //window.location.href = url;
              window.location.href = obj.paymentUrl;
            } else {
              console.log('unable to get payment URL');
            }
          
             
         // history('/dashboard');
        //history('{response.data.paymentURL}');
        //window.location.href =response.data.paymentURL;
       //window.location.href ="https://developers.google.com/waze/deeplinks";


      } catch (error) {
          console.error('Transaction failed:', error.response ? error.response.data : error.message);
          setError('Invalid username or password.');
      }
  };
  

 /*  useEffect(() => {

    const token = sessionStorage.getItem('jwtToken'); // Retrieve JWT token from localStorage
    console.log('JWT token retrieved:', token);

    // Make an HTTP GET request to the backend API
    axios.get('http://localhost:8080/orders/{userId}' , {
        headers: {
          "Authorization": `Bearer ${token}`,  // Attach JWT token to Authorization header
          
          //"Content-Type": "application/json"    // Optional: You can specify other headers if needed
        }
      }
    )
    
      .then(response => {
        setMessage(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      });
  }, []);

  if(sessionStorage.getItem('jwtToken')==null) {
    return(
        <p className="text-center">You need to be logged in.</p>
    )
} */

  return (
    <div>
      <h1>Message from Backend: {message}</h1>

      <hr/>

      <div className="d-flex justify-content-center align-items-center vh-100">
                  <div className="border rounded-lg p-4" style={{ width: '500px', height: 'auto' }}>
                      <MDBContainer className="p-3">
                          <h2 className="mb-4 text-center">WALLET</h2>
                          <MDBInput wrapperClass='mb-4' placeholder='CUSTOM AMOUNT' id='amt' value={totalAmount} type='amt' 
                          onChange={(e) => setTotalAmount(e.target.value)} />
                        
                          {error && <p className="text-danger">{error}</p>} {/* Render error message if exists */}
                          <button className="mb-4 d-block btn-primary" style={{ height:'30px',width: '34%' }} onClick={handleLogin}>➕ TOP UP</button>
                          <div className="text-center">
                              <p>Not a member? <a href="/signup" >Register</a></p>
                          </div>
                      </MDBContainer>
                  </div>
              </div>
    </div>
  );
};

export default CreateOrder;

    /* "orderItem":"$10 Credit",
    "orderDate": "2024-12-05",
    "orderPrice": 10.00,
    "totalAmount": 10.00 */